
import MinusCirlce from "../../../assets/duotone/MinusCirlce.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MinusCirlceIcon({ className, dataTestid = "MinusCirlceIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MinusCirlce data-testid={dataTestid} className={classes} {...rest} />
  );
}
